window.addEventListener('DOMContentLoaded', () => {
  document.body.addEventListener('click', event => {
    const element = event.target as HTMLElement;
    if (element.tagName.toLowerCase() == 'a' && element.id == 'page-top') {
      event.preventDefault();
      window.scrollTo(0, 0);
    }
  });
});
